import { ReduxUpdater } from '../../pdf/ReduxUpdater';
import Command from './_Command';
import { ApryseUpdater } from '../../pdf/ApryseUpdater';
import { ApryseSDK } from '../../pdf/ApryseSDK';
import { CustomHistoryManager, type ISpecificChangeInfo } from '../../pdf/CustomHistoryManager';

export default class GenericDropdownButton extends Command {
    constructor(
        public readonly Enabled: boolean,
        private readonly type: string,
        public readonly Text: string,
        public readonly Key: string,
        private readonly code: string,
        public readonly OpenContextMenu: boolean,
        public readonly Icon?: JSX.Element,
        public readonly IconColor?: string,
        public readonly IconBackgroundColor?: string,
    ) {
        super({
            Enabled,
            Key,
            Icon,
            IconColor,
            IconBackgroundColor,
            OpenContextMenu,
            Path: false,
            Text,
            Callback: () => {
                if (ApryseUpdater.selectedAnnotations.length > 0) {
                    const snapshotBefore = CustomHistoryManager.takeAnnotationsSnapshot();

                    switch (type) {
                        case 'color': {
                            ApryseUpdater.selectedAnnotations.forEach(annot => {
                                ApryseSDK.annotColor(annot, parseInt(code));
                            });
                            break;
                        }
                        case 'fillColor': {
                            ApryseUpdater.selectedAnnotations.forEach(annot => {
                                ApryseSDK.annotFillColor(
                                    annot,
                                    parseInt(code) > 0 ? 0xff000000 + parseInt(code) : 0,
                                );
                            });
                            break;
                        }
                        case 'lineWidth': {
                            ApryseUpdater.selectedAnnotations.forEach(annot => {
                                ApryseSDK.annotThickness(annot, parseFloat(code));
                            });
                            break;
                        }
                        case 'lineStyle':
                        case 'lineCloudyStyle': {
                            ApryseUpdater.selectedAnnotations.forEach(annot => {
                                ApryseSDK.applyStyling(annot, code);
                            });
                            break;
                        }
                        case 'lineStart': {
                            ApryseUpdater.selectedAnnotations.forEach(annot => {
                                ApryseSDK.annotStartStyle(
                                    annot,
                                    ApryseSDK.stringToLineEndingStyle(code),
                                );
                            });
                            break;
                        }
                        case 'lineEnd': {
                            ApryseUpdater.selectedAnnotations.forEach(annot => {
                                ApryseSDK.annotEndStyle(
                                    annot,
                                    ApryseSDK.stringToLineEndingStyle(code),
                                );
                            });
                            break;
                        }
                    }

                    ApryseSDK.handleAnnotationChanged(
                        ApryseUpdater.selectedAnnotations,
                        'modify',
                        type as ISpecificChangeInfo,
                        snapshotBefore,
                    );
                    ReduxUpdater.ribbonRefresh();
                    ReduxUpdater.annotationSidepanelRefresh();
                } else {
                    switch (type) {
                        case 'color': {
                            ReduxUpdater.selectedColor = parseInt(code);
                            break;
                        }
                        case 'fillColor': {
                            ReduxUpdater.selectedFillColor = parseInt(code);
                            break;
                        }
                        case 'lineWidth': {
                            ReduxUpdater.selectedLineWidth = parseFloat(code);
                            break;
                        }
                        case 'lineStyle': {
                            ReduxUpdater.selectedLineStyle = code;
                            break;
                        }
                        case 'lineCloudyStyle': {
                            ReduxUpdater.selectedLineCloudyStyle = code;
                            break;
                        }
                        case 'lineStart': {
                            if (ReduxUpdater.stateName === ApryseSDK.ToolsENUM.CREATE_ARROW) {
                                ReduxUpdater.selectedArrowStart = code;
                            } else {
                                ReduxUpdater.selectedLineStart = code;
                            }
                            break;
                        }
                        case 'lineEnd': {
                            if (ReduxUpdater.stateName === ApryseSDK.ToolsENUM.CREATE_ARROW) {
                                ReduxUpdater.selectedArrowEnd = code;
                            } else {
                                ReduxUpdater.selectedLineEnd = code;
                            }
                            break;
                        }
                    }
                }
                // ToDO: updateUserSettings();
            },
        });
    }
}
